import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { authClient, hasToken, saveToken, clearToken, formatApiErrorDetail } from "../lib/authClient";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null (unknown), object (auth'd), or false (not auth'd)
  const [checking, setChecking] = useState(true);

  const refresh = useCallback(async () => {
    if (!hasToken()) {
      setUser(false);
      setChecking(false);
      return;
    }
    try {
      const { data } = await authClient.get("/api/auth/me");
      setUser(data);
    } catch (_) {
      setUser(false);
    } finally {
      setChecking(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    try {
      const { data } = await authClient.post("/api/auth/login", { email, password });
      saveToken(data.access_token);
      setUser(data.user);
      return { ok: true, user: data.user };
    } catch (e) {
      const msg = formatApiErrorDetail(e?.response?.data?.detail) || e.message;
      return { ok: false, error: msg };
    }
  };

  const logout = () => {
    clearToken();
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, checking, login, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}
